import { render, staticRenderFns } from "./MojiArt.vue?vue&type=template&id=1cbcbec2&scoped=true&"
import script from "./MojiArt.vue?vue&type=script&lang=js&"
export * from "./MojiArt.vue?vue&type=script&lang=js&"
import style0 from "./MojiArt.vue?vue&type=style&index=0&id=1cbcbec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbcbec2",
  null
  
)

export default component.exports